import { Spin, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { uploadFile } from "../../assets/svg";
import { dummyRequestAudio } from "../../helper/helpers";
import { acceptedAudio, uploadAudioFileSize } from "../../constants/constants";

import "./styles.scss";
const { Dragger } = Upload;

const AudioUpload = ({
  setAudioFileData,
  audioRef,
  handlePlayPause,
  resetAudio,
  setAudioError,
}) => {
  const [state, setState] = useState({
    audio: "",
    loading: false,
    error: false,
  });
  const props = {
    name: "file",
    accept: "audio/*",
    showUploadList: false,
    customRequest: dummyRequestAudio(acceptedAudio, uploadAudioFileSize),
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status === "uploading") {
        setState((st) => ({ ...st, loading: true }));
      }
      if (info.file.status === "done") {
        setState((st) => ({ ...st, loading: false, error: false }));
        uploadAudioFile(info.file.originFileObj);
        setAudioFileData(info.file.originFileObj);
        setAudioError(false, "");
      }
      if (info.file.status === "error") {
        setState((st) => ({ ...st, loading: false, error: true }));
        if (info.file?.error?.includes("Unsupported")) {
          setAudioError(true, "Unsupported File Format");
        }
      }
    },
    beforeUpload: (info) => {
      if (info.size >= uploadAudioFileSize) {
        setAudioError(true, "File size has exceeded its max limit of 4MB.");
      }
      if (info.size === 0) {
        setAudioError(
          true,
          "File size is too short. Please upload another file."
        );
      }
    },
  };
  const uploadAudioFile = (file) => {
    if (file) {
      setState((st) => ({
        ...st,
        audio: URL.createObjectURL(file),
      }));
    }
  };

  useEffect(
    () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
        // handlePlayPause("Play");
      }
      if (state.audio) {
        audioRef.current = new Audio(state.audio);
        audioRef.current.onended = () => {
          handlePlayPause("Play");
        };
      }
    },
    [state.audio]
  );

  useEffect(
    () => {
      setState((st) => ({
        ...st,
        audio: null,
        error: false,
      }));
      audioRef.current && audioRef.current.pause();
      audioRef.current = null;
    },
    [resetAudio]
  );

  return (
    <div className="audio-file-upload-wrapper" id="audio-file-upload-wrapper">
      <Dragger
        className="file-uploader"
        disabled={state.loading || state.audio}
        {...props}
      >
        {state.loading ? (
          <Spin tip="Uploading..." />
        ) : state?.audio ? null : (
          <>
            <span className="ant-upload-drag-icon">{uploadFile}</span>
            <p className="ant-upload-text">
              <span className="hide-for-mob"> Drag and Drop or </span>
              <span className="choose-file">Choose Audio File</span>
            </p>
            <p className="ant-upload-text note">
              <strong>Note: </strong>
              Only "mp3" and "ogg" file extensions are acceptable
            </p>
          </>
        )}
      </Dragger>
    </div>
  );
};

export default AudioUpload;
